export interface SsoAccountInfoModel {

    account: Account;
    roles: Roles[]
   
}

export interface Account {
    ssoAccountId?: string;
    accountId?: string;
    emailAddress?: string;
    fullName?: string;
    shortName?:string;
}
export interface Roles {
    ssoRoleId?: string,
    roleName?: string
}
